(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-geo-test"] && !Shopify.designMode) return;
  try {
    
  class OrigenIpGeoTest {
    constructor(section) {
      this.section = section;
      this.targetCountry = (section.dataset.targetCountry || 'US').toUpperCase();
      this.apiUrl = section.dataset.apiUrl || 'https://ipapi.co/json/';
      this.countryText = section.querySelector('[data-country-text]');
      this.debug = section.querySelector('[data-country-debug]');
      this.checkCountry();
    }

    async checkCountry() {
      try {
        const response = await fetch(this.apiUrl, { cache: 'no-store' });

        if (!response.ok) {
          throw new Error('Geo request failed');
        }

        const data = await response.json();
        const countryCode = String(data.country_code || data.countryCode || data.country || '').toUpperCase();
        const shouldShow = countryCode === this.targetCountry;

        if (this.countryText) {
          this.countryText.hidden = !shouldShow;
        }

        if (this.debug) {
          this.debug.textContent = `IP country: ${countryCode || 'unknown'} · Target: ${this.targetCountry}`;
        }
      } catch (error) {
        if (this.countryText) {
          this.countryText.hidden = true;
        }

        if (this.debug) {
          this.debug.textContent = `IP country: unavailable · Target: ${this.targetCountry}`;
        }
      }
    }
  }

  document.querySelectorAll('[data-origen-ip-geo-test]').forEach((section) => {
    new OrigenIpGeoTest(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-origen-product-detail]').forEach((section) => {
    const variantsScript = section.querySelector('[data-origen-product-variants]');
    const form = section.querySelector('[data-origen-product-form]');
    const idInput = section.querySelector('[data-origen-product-variant-id]');
    const submit = section.querySelector('[data-origen-product-submit]');
    const priceCurrent = section.querySelector('[data-origen-product-price-current]');
    const priceCompare = section.querySelector('[data-origen-product-price-compare]');
    const message = section.querySelector('[data-origen-product-message]');
    const optionValueLabels = section.querySelectorAll('[data-origen-product-option-value]');
    const paintColorInput = section.querySelector('[data-origen-paint-color-property]');
    const paintColorTriggers = section.querySelectorAll('[data-origen-paint-color-trigger]');

    if (!variantsScript || !form || !idInput || !submit) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const getSelectedOptions = () => {
      const selected = [];

      section.querySelectorAll('[data-origen-product-option-input]:checked').forEach((input) => {
        selected[Number(input.dataset.optionIndex)] = input.value;
      });

      return selected;
    };

    const findVariant = () => {
      const selected = getSelectedOptions();

      return variants.find((variant) => variant.options.every((option, index) => option === selected[index]));
    };

    const updateOptionLabels = () => {
      optionValueLabels.forEach((label) => {
        const selectedInput = section.querySelector(
          `[data-origen-product-option-input][data-option-index="${label.dataset.origenProductOptionValue}"]:checked`
        );

        if (selectedInput) {
          label.textContent = selectedInput.value;
        }
      });
    };

    const updateState = () => {
      const variant = findVariant();
      updateOptionLabels();

      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.soldOutLabel || submit.textContent;
        if (message) message.hidden = false;
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available
        ? submit.dataset.addLabel || submit.textContent
        : submit.dataset.soldOutLabel || submit.textContent;

      if (message) message.hidden = Boolean(variant.available);

      if (priceCurrent) {
        priceCurrent.textContent = variant.priceFormatted;
      }

      if (priceCompare) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          priceCompare.textContent = variant.compareAtFormatted;
          priceCompare.classList.remove('is-hidden');
        } else {
          priceCompare.classList.add('is-hidden');
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelectorAll('[data-origen-product-option-input]').forEach((input) => {
      input.addEventListener('change', updateState);
    });

    paintColorTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (paintColorInput) {
          paintColorInput.value = trigger.dataset.colorValue || '';
        }

        paintColorTriggers.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        trigger.classList.add('is-selected');
        trigger.setAttribute('aria-pressed', 'true');
      });
    });

    updateState();
  });

  /* Lead-gate for download links */
  (() => {
    const WEBHOOK_URL = 'https://n8n.pablonicolas.studio/webhook/origenpaints';

    document.querySelectorAll('.origen-product-detail__download').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const pdfUrl = link.href;
        const shopifySection = link.closest('.shopify-section') || document.body;
        const overlay = shopifySection.querySelector('.opd-gate-overlay')
          || document.querySelector('.opd-gate-overlay');
        if (!overlay) { window.open(pdfUrl, '_blank'); return; }

        overlay.removeAttribute('hidden');
        overlay._pdfUrl = pdfUrl;
        overlay.querySelector('input[name="name"]')?.focus();
      });
    });

    document.querySelectorAll('.opd-gate-overlay').forEach((overlay) => {
      const backdrop = overlay.querySelector('.opd-gate-backdrop');
      const closeBtn = overlay.querySelector('.opd-gate-close');
      const form = overlay.querySelector('.opd-gate-form');
      const submit = overlay.querySelector('.opd-gate-submit');
      const errorMsg = overlay.querySelector('.opd-gate-error');

      const close = () => overlay.setAttribute('hidden', '');

      backdrop?.addEventListener('click', close);
      closeBtn?.addEventListener('click', close);
      overlay.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

      form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const name = form.querySelector('[name="name"]').value.trim();
        const company = form.querySelector('[name="company"]').value.trim();
        const email = form.querySelector('[name="email"]').value.trim();

        if (!name || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorMsg?.removeAttribute('hidden');
          return;
        }

        errorMsg?.setAttribute('hidden', '');
        submit.disabled = true;

        try {
          await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name,
              company,
              email,
              product: document.title,
              page: window.location.href,
              pdf: overlay._pdfUrl,
            }),
          });
        } catch (_) { /* webhook failure is silent — still deliver the PDF */ }

        window.open(overlay._pdfUrl, '_blank');
        close();
        form.reset();
        submit.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('random-related-products')) {
    customElements.define(
      'random-related-products',
      class RandomRelatedProducts extends HTMLElement {
        connectedCallback() {
          const grid = this.querySelector('[data-related-products-grid]');
          const templates = Array.from(this.querySelectorAll('[data-related-product-template]'));
          if (!grid || templates.length === 0) {
            this.closest('.origen-related')?.setAttribute('hidden', '');
            return;
          }

          for (let index = templates.length - 1; index > 0; index -= 1) {
            const randomIndex = Math.floor(Math.random() * (index + 1));
            [templates[index], templates[randomIndex]] = [templates[randomIndex], templates[index]];
          }

          const fragment = document.createDocumentFragment();
          templates.slice(0, 4).forEach((template) => fragment.appendChild(template.content.cloneNode(true)));
          grid.replaceChildren(fragment);
        }
      }
    );
  }

  if (!window.__origenRelatedQuickAddBound) {
    window.__origenRelatedQuickAddBound = true;

    const closeRelatedDialog = (dialog) => {
      if (dialog?.open) dialog.close();
    };

    document.addEventListener('click', (event) => {
      const colorButton = event.target.closest('[data-origen-related-color]');
      if (colorButton) {
        const form = colorButton.closest('[data-origen-related-form]');
        const input = form?.querySelector('[data-origen-related-color-property]');
        const buttons = form?.querySelectorAll('[data-origen-related-color]') || [];
        if (input) input.value = colorButton.dataset.colorValue || '';
        buttons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        colorButton.classList.add('is-selected');
        colorButton.setAttribute('aria-pressed', 'true');
        return;
      }

      const openButton = event.target.closest('[data-origen-related-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.dataset.origenRelatedOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-origen-related-close]');
      if (closeButton) {
        closeRelatedDialog(closeButton.closest('[data-origen-related-dialog]'));
        return;
      }

      if (event.target.matches('[data-origen-related-dialog]')) closeRelatedDialog(event.target);
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-origen-related-form]');
      if (!form) return;
      event.preventDefault();
      const dialog = form.closest('[data-origen-related-dialog]');
      const submit = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-origen-related-message]');
      const formData = new FormData(form);
      submit.disabled = true;
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || dialog.dataset.errorMessage);
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'origen-related-products',
            data: {
              source: 'origen-related-products',
              itemCount: cart.item_count,
              variantId: String(formData.get('id') || '')
            }
          }
        }));

        if (message) {
          message.textContent = dialog.dataset.successMessage || '';
          message.hidden = false;
        }
        setTimeout(() => {
          closeRelatedDialog(dialog);
          document.querySelector('cart-drawer-component')?.open?.();
        }, 350);
      } catch (error) {
        if (message) {
          message.textContent = error.message || dialog.dataset.errorMessage || '';
          message.hidden = false;
        }
      } finally {
        submit.disabled = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-shop-story-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function openDialog(button) {
      const dialog = document.getElementById(button.dataset.origenShopQuickOpen);
      if (!dialog || dialog.open) return;
      dialog.showModal();
    }

    function closeDialog(dialog) {
      if (dialog?.open) dialog.close();
    }

    async function addToCart(form) {
      const dialog = form.closest('[data-origen-shop-quick-dialog]');
      const submit = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-origen-shop-quick-message]');
      const formData = new FormData(form);

      submit.disabled = true;
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const addResult = await addResponse.json();

        if (!addResponse.ok || addResult.status) {
          throw new Error(addResult.description || addResult.message || dialog.dataset.errorMessage);
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'origen-shop-story-cards',
            data: {
              source: 'origen-shop-story-cards',
              itemCount: cart.item_count,
              variantId: String(formData.get('id') || '')
            }
          }
        }));

        if (message) {
          message.textContent = dialog.dataset.successMessage || '';
          message.hidden = false;
        }

        setTimeout(() => {
          closeDialog(dialog);
          document.querySelector('cart-drawer-component')?.open?.();
        }, 350);
      } catch (error) {
        if (message) {
          message.textContent = error.message || dialog.dataset.errorMessage || '';
          message.hidden = false;
        }
      } finally {
        submit.disabled = false;
      }
    }

    document.addEventListener('click', (event) => {
      const colorButton = event.target.closest('[data-origen-shop-color-trigger]');
      if (colorButton) {
        const form = colorButton.closest('[data-origen-shop-quick-form]');
        const colorInput = form?.querySelector('[data-origen-shop-color-property]');
        const colorButtons = form?.querySelectorAll('[data-origen-shop-color-trigger]') || [];

        if (colorInput) {
          colorInput.value = colorButton.dataset.colorValue || '';
        }

        colorButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        colorButton.classList.add('is-selected');
        colorButton.setAttribute('aria-pressed', 'true');
        return;
      }

      const openButton = event.target.closest('[data-origen-shop-quick-open]');
      if (openButton) {
        openDialog(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-origen-shop-quick-close]');
      if (closeButton) {
        closeDialog(closeButton.closest('[data-origen-shop-quick-dialog]'));
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('[data-origen-shop-quick-dialog]')) {
        closeDialog(event.target);
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-origen-shop-quick-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-shop-story-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function openDialog(button) {
      const dialog = document.getElementById(button.dataset.origenShopQuickOpen);
      if (!dialog || dialog.open) return;
      dialog.showModal();
    }

    function closeDialog(dialog) {
      if (dialog?.open) dialog.close();
    }

    async function addToCart(form) {
      const dialog = form.closest('[data-origen-shop-quick-dialog]');
      const submit = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-origen-shop-quick-message]');
      const formData = new FormData(form);

      submit.disabled = true;
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const addResult = await addResponse.json();

        if (!addResponse.ok || addResult.status) {
          throw new Error(addResult.description || addResult.message || dialog.dataset.errorMessage);
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'origen-shop-story-cards',
            data: {
              source: 'origen-shop-story-cards',
              itemCount: cart.item_count,
              variantId: String(formData.get('id') || '')
            }
          }
        }));

        if (message) {
          message.textContent = dialog.dataset.successMessage || '';
          message.hidden = false;
        }

        setTimeout(() => {
          closeDialog(dialog);
          document.querySelector('cart-drawer-component')?.open?.();
        }, 350);
      } catch (error) {
        if (message) {
          message.textContent = error.message || dialog.dataset.errorMessage || '';
          message.hidden = false;
        }
      } finally {
        submit.disabled = false;
      }
    }

    document.addEventListener('click', (event) => {
      const colorButton = event.target.closest('[data-origen-shop-color-trigger]');
      if (colorButton) {
        const form = colorButton.closest('[data-origen-shop-quick-form]');
        const colorInput = form?.querySelector('[data-origen-shop-color-property]');
        const colorButtons = form?.querySelectorAll('[data-origen-shop-color-trigger]') || [];

        if (colorInput) {
          colorInput.value = colorButton.dataset.colorValue || '';
        }

        colorButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        colorButton.classList.add('is-selected');
        colorButton.setAttribute('aria-pressed', 'true');
        return;
      }

      const openButton = event.target.closest('[data-origen-shop-quick-open]');
      if (openButton) {
        openDialog(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-origen-shop-quick-close]');
      if (closeButton) {
        closeDialog(closeButton.closest('[data-origen-shop-quick-dialog]'));
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('[data-origen-shop-quick-dialog]')) {
        closeDialog(event.target);
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-origen-shop-quick-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-story-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function openDialog(button) {
      const dialog = document.getElementById(button.dataset.origenStoryQuickOpen);
      if (!dialog || dialog.open) return;
      dialog.showModal();
    }

    function closeDialog(dialog) {
      if (dialog?.open) dialog.close();
    }

    async function addToCart(form) {
      const dialog = form.closest('[data-origen-story-quick-dialog]');
      const submit = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-origen-story-quick-message]');
      const formData = new FormData(form);

      submit.disabled = true;
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const addResult = await addResponse.json();

        if (!addResponse.ok || addResult.status) {
          throw new Error(addResult.description || addResult.message || dialog.dataset.errorMessage);
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'origen-story-cards',
            data: {
              source: 'origen-story-cards',
              itemCount: cart.item_count,
              variantId: String(formData.get('id') || '')
            }
          }
        }));

        if (message) {
          message.textContent = dialog.dataset.successMessage || '';
          message.hidden = false;
        }

        setTimeout(() => {
          closeDialog(dialog);
          document.querySelector('cart-drawer-component')?.open?.();
        }, 350);
      } catch (error) {
        if (message) {
          message.textContent = error.message || dialog.dataset.errorMessage || '';
          message.hidden = false;
        }
      } finally {
        submit.disabled = false;
      }
    }

    document.addEventListener('click', (event) => {
      const colorButton = event.target.closest('[data-origen-story-color-trigger]');
      if (colorButton) {
        const form = colorButton.closest('[data-origen-story-quick-form]');
        const colorInput = form?.querySelector('[data-origen-story-color-property]');
        const colorButtons = form?.querySelectorAll('[data-origen-story-color-trigger]') || [];

        if (colorInput) {
          colorInput.value = colorButton.dataset.colorValue || '';
        }

        colorButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        colorButton.classList.add('is-selected');
        colorButton.setAttribute('aria-pressed', 'true');
        return;
      }

      const openButton = event.target.closest('[data-origen-story-quick-open]');
      if (openButton) {
        openDialog(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-origen-story-quick-close]');
      if (closeButton) {
        closeDialog(closeButton.closest('[data-origen-story-quick-dialog]'));
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('[data-origen-story-quick-dialog]')) {
        closeDialog(event.target);
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-origen-story-quick-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
